import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import Field from 'redux-form/lib/Field';
import reduxForm from 'redux-form/lib/reduxForm';
import formValueSelector from 'redux-form/lib/formValueSelector';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import AvailabilityCalendar from '../../../../components/ViewListing/AvailabilityCalendar';
import Loader from '../../../../components/Loader';
import IncrementBtnCircle from '../../../../components/IncrementBtnCircle';
import { withQuery } from '../../../../hoc/withGraphql';

import BlockedDatesQuery from '../../../../routes/viewListing/BlockedDates.graphql';
import ListingDataQuery from '../../../../routes/viewListing/getListingData.graphql';
import messages from '../../../../locale/messages';
import { getFixedValue } from '../../../../helpers/currencyConvertion';
import gusetIcon from '/public/SiteIcons/paymenyGusetIcon.svg';
import { applyPaymentModal } from '../../../../actions/modalActions';
import { getCalculationDetails } from '../../../../helpers/Pricing/getCalculationDetails';

import bt from '../../../../components/commonStyle.css';
import s from './ModalForm.css';
class EditPayment extends Component {

	renderIncrementButton = (field) => (
		<IncrementBtnCircle
			{...field}
		/>
	);

	handleSubmitButton = async () => {
		const { applyPaymentModal, checkIn, checkOut, guests, specialPricing, serviceFees, base, rates, currency, toCurrency } = this.props;
		let { listData: { listingData: { weeklyDiscount, monthlyDiscount, basePrice, cleaningPrice, tax, weekendPrice, customDiscounts, extraGuestThreshold, extraGuestFee } } } = this.props;
		const { formatMessage } = this.props.intl;
		const { taxes, isSpecialPriceAssigned, guestServiceFee, hostServiceFee, bookingSpecialPricing,
			priceForDays, isAverage, total, discount, dayDifference, discountType,
			guestServiceFeeType, hostServiceFeeType, guestServiceFeeValue, hostServiceFeeValue, totalIncludeTax,
			extraGuestFeeAmount, extraGuestCount
		} = getCalculationDetails({
			startDate: checkIn, basePrice, cleaningPrice, monthlyDiscount, weeklyDiscount, customDiscounts, formatMessage,
			serviceFees, specialPricing, toCurrency, tax, currency, endDate: checkOut, base, rates,
			extraGuestThreshold, extraGuestFee, weekendPrice, guests: guests || 1
		});

		const currentFormValues = {
			discount,
			discountType,
			guestServiceFee: getFixedValue(guestServiceFee),
			hostServiceFee: getFixedValue(hostServiceFee),
			total: getFixedValue(totalIncludeTax),
			isSpecialPriceAssigned,
			bookingSpecialPricing: JSON.stringify(bookingSpecialPricing),
			isSpecialPriceAverage: getFixedValue(isAverage),
			priceForDays: getFixedValue(priceForDays),
			totalValue: getFixedValue(total),
			taxPrice: getFixedValue(taxes),
			dayDifference,
			hostServiceFeeType,
			hostServiceFeeValue,
			guestServiceFeeType,
			guestServiceFeeValue,
			extraGuestFeeAmount: getFixedValue(extraGuestFeeAmount),
			extraGuestCount,
			extraGuestFee: getFixedValue(extraGuestFee),
		};

		await applyPaymentModal({ checkIn, checkOut, guests, currentFormValues });
	}

	render() {
		const { listId, checkIn, checkOut, maximumStay, guests, minimumStay, availability, isLoading } = this.props;
		const { ListingBlockedDates, getListingData: { loading, UserListing } } = this.props;
		const { formatMessage } = this.props.intl;
		let disabled = false, isDateChosen = checkIn != null && checkOut != null || false;

		if (maximumStay || minimumStay || !availability || !isDateChosen) disabled = true;

		if (loading && !UserListing) {
			return <Loader type="text" />
		} else {
			return (
				<>
					<div className={s.flex}>
						<div>
							<div className={s.title}><FormattedMessage {...messages.guests} /></div>
							<div className={cx(s.guestModalFlex, 'svgImg')}><img src={gusetIcon} className={cx(s.iconCss, 'iconCssRTL')} /><span>{guests} {' '} {guests > 1 ? <FormattedMessage {...messages.guests} /> : <FormattedMessage {...messages.guest} />}</span></div>
						</div>
						<div>
							<Field
								name="guests"
								type="text"
								component={this.renderIncrementButton}
								maxValue={UserListing.personCapacity}
								minValue={1}
								incrementBy={1}
							/>
						</div>
					</div>

					<AvailabilityCalendar
						listId={listId}
						loading={loading || ListingBlockedDates?.loading}
						blockedDates={
							ListingBlockedDates?.UserListing != null ?
								ListingBlockedDates?.UserListing.blockedDates : undefined
						}
						listingData={UserListing?.listingData || undefined}
						country={UserListing?.country}
						queryStartDate={checkIn}
						queryEndDate={checkOut}
						formName={'PaymentFormModal'}
						paymentCalendar={true}
						containerClassName='paymentCalendarHeight'
					/>
					<div className={cx(s.textAignRight, 'textAlignLeftRtlEdit')}>
						<Loader
							className={bt.btnPrimary}
							disabled={disabled || isLoading}
							type={'button'}
							handleClick={this.handleSubmitButton}
							label={formatMessage(messages.applyFilters)}
						>
						</Loader>
					</div>

					{
						!isLoading && maximumStay &&
						<div className={s.errorMessage}>
							<FormattedMessage {...messages.maximumStay} /> {UserListing.listingData.maxNight} {UserListing.listingData.maxNight > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
						</div>
					}
					{
						!isLoading && minimumStay &&
						<div className={s.errorMessage}>
							<FormattedMessage {...messages.minimumNightStay} /> {UserListing.listingData.minNight} {UserListing.listingData.minNight > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
						</div>
					}
					{
						!isLoading && !availability && !maximumStay && !minimumStay &&
						<div className={s.errorMessage}>
							<FormattedMessage {...messages.hostErrorMessage2} />
						</div>
					}
				</>
			);
		}

	}
}

EditPayment = reduxForm({
	form: 'PaymentFormModal', // a unique name for this form
	destroyOnUnmount: true
})(EditPayment);

const selector = formValueSelector('PaymentFormModal');
const selectorPayment = formValueSelector('PaymentForm');

const mapState = (state) => ({
	availability: state.viewListing.availability,
	maximumStay: state.viewListing.maximumStay,
	minimumStay: state.viewListing.minimumStay,
	isLoading: state.viewListing.isLoading,
	checkIn: selector(state, 'checkIn'),
	checkOut: selector(state, 'checkOut'),
	guests: selector(state, 'guests'),
	serviceFees: state.book.serviceFees,
	base: state.currency.base,
	rates: state.currency.rates,
	listData: state.book.data,
	currency: selectorPayment(state, 'currency'),
	specialPricing: state.viewListing.specialPricing,
	toCurrency: state.currency.to || state.currency.base,
});

const mapDispatch = {
	applyPaymentModal
};

export default compose(
	injectIntl,
	withStyles(s, bt),
	connect(mapState, mapDispatch),
	withQuery(ListingDataQuery,
		{
			name: 'getListingData',
			options: (props) => ({
				variables: {
					listId: props.listId,
					preview: true,
				},
				fetchPolicy: 'network-only',
				ssr: false
			})
		}
	),
	withQuery(BlockedDatesQuery,
		{
			name: 'ListingBlockedDates',
			options: (props) => ({
				variables: {
					listId: props.listId,
					preview: true,
				},
				fetchPolicy: 'network-only',
				ssr: false
			})
		}
	))(EditPayment);